export default __webpack_public_path__ + "static/media/icon-ranking-3.cd57d5fd.svg";